import React, {useEffect,memo} from 'react';
import styled from "styled-components";
import {useSelector} from "react-redux";
import termsConditonReducer, {fetchPosts} from "../api/redux/termscondition";
import {Col, Container, Row} from "react-bootstrap";
import Title from "../../components/Title";
import {hover} from '../../styles/globalStyleVars'
import gsap, {CSSPlugin, TimelineLite} from "gsap";
import reactHtmlParser from "react-html-parser";
import {NextSeo} from "next-seo";
import {wrapper} from "../api/store";
import {ApiServices} from "../api/network/ApiServices";
import {ApiParamKey} from "../api/network/ApiParamKey";
import {useRouter} from "next/router";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";

const TermsandCondition = ({offset}) => {


    let getPost = useSelector(state => state.termsConditonReducer)
    let page_data = getPost?.posts?.data?.page_data
    let load_list = getPost?.posts?.download_list
    const download_cta = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'downloads-cta');
    const banner = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'banner-about');



    // for 404 page
    useEffect(() => {
        setTimeout(() => {
            const tl = new TimelineLite()
            tl.to('.page-transition', {
                delay: 1,
                opacity: 0,
                duration: 1,
                display: 'none'
            }).to('.page-transition .logo', {
                duration: .6,
                opacity: 0
            }, '-=.6')
        }, 1500)


        ScrollTrigger.refresh();

        // Scroll to top when page changes
        window.scrollTo(0, 0);

    }, [getPost])


    const router = useRouter();
    const currentUrl = router && router.asPath;

    useEffect(() => {
        ScrollTrigger.refresh();

        // Scroll to top when page changes
        window.scrollTo(0, 0);
    }, [router]);

    return (
        <>
            <NextSeo
                title={`${page_data?.title ? reactHtmlParser(page_data?.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited' }`}
                description={page_data?.meta_description}
                canonical={"https://www.shantasecurities.com"+currentUrl}
                openGraph={{
                    type: 'website',
                    url: "https://www.shantasecurities.com"+currentUrl,
                    title: reactHtmlParser(page_data?.og_title),
                    description: page_data?.og_description,
                    images: [
                        {
                            url: banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                        {
                            url:  banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                    ],
                }}
            />

            <StyledComponent>
                <Container>
                    <Row>
                        <Col md={12} className=" pt-200 pb-200">
                            <Title noanim text={'Terms and Conditions'}
                                   fontSize={'44'} fontWeight={'400'} margin={'0 0 40px'} lineHeight={'56'}/>

                            <div className="content">

                                {
                                    page_data?.description ?
                                    reactHtmlParser(page_data?.description) :
                                        reactHtmlParser('<p> These terms and conditions ("Terms") govern the use of financial securities services provided by Shanta Securities Limited to its clients. By engaging our services, you agree to abide by these Terms. Please read them carefully. </p><br><br><h6> 1. Definitions</h6><br><ul><li> 1.1 "Company" refers to Shanta Securities Limited, a Brokerage company registered in Bangladesh.</li><li> 1.2 "Client" refers to the individual or entity engaging the services of the Company.</li></ul><br><br><h6> 2. Services</h6><br><ul><li>2.1 The Company agrees to provide  brokerage services to the clients. </li><li>2.2 The client acknowledges that investment in securities carries inherent risks, and the Company does not guarantee profits or protection against losses.</li></ul><br><br><h6> 3. Client Responsibilities </h6><br><ul><li>3.1 The client shall adhere to all relevant laws and regulations governing financial transactions in Bangladesh. </li></ul><br><br><h6>4. Confidentiality and Data Protection </h6><br><ul><li>4.1 The Company shall maintain the confidentiality of client information in compliance with applicable data protection laws in Bangladesh.</li></ul><br><br><h6>5. Risk Disclosure </h6><br><ul><li>5.1  The client acknowledges and understands the risks associated with securities transactions and investments.</li><li>5.2  The Company shall provide periodic updates to the client.</li></ul><br><br><h6>6. Fees and Charges </h6><br><ul><li>6.1 The client agrees to pay fees and charges for the  brokerage services as  per mutual agreement.</li><li>6.2 The Company reserves the right to revise fees and charges upon providing reasonable notice to the client.</li></ul><br><br><h6>7. Compliance with Laws </h6><br><ul><li>7.1 Both parties shall comply with all applicable laws and regulations in Bangladesh related to securities brokerage.</li></ul><br><br><h6>8. Termination </h6><br><ul><li>8.1 Either party may terminate the service agreement in accordance with the terms specified in the account opening form.</li></ul><br><br><h6>9. Governing Law </h6><br><ul><li>9.1 These Terms shall be governed by and construed in accordance with the laws of Bangladesh.</li></ul><br><br><br>')
                                }

                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </>
    );
};


const StyledComponent = styled.section`
    min-height: 80vh;
    
    a{
        color: ${hover};
    }

    ul, ol {
        li {
            padding-left: 20px;
            position: relative;
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            &:after {
                height: 10px;
                width: 10px;
                background: ${hover};
                content: '';
                position: absolute;
                left: 0;
                top: 5px;
                border-radius: 50%;
            }
        }
    }
`;
TermsandCondition.getInitialProps = wrapper.getInitialPageProps((store) => async () => {
    let api_services = ApiServices.SECTIONS;
    let param = {
        [ApiParamKey.TYPE]: 'slug',
        [ApiParamKey.VALUE]: 'terms-conditions',
        [ApiParamKey.GET_SECTION]: 'yes',
        [ApiParamKey.IMAGE]: 'yes',
        [ApiParamKey.POST]: 'yes',
        [ApiParamKey.GALLERY]: 'yes',
    }
    await store.dispatch(fetchPosts([api_services, param]));
});

export default TermsandCondition;
